<template>
  <BaseDialogFrame
    :header
    :closeable
    :header-class="headerClass"
    :footer-class="footerClass"
    @on-click-outside="emit('onReject')"
    @close="emit('onReject')"
  >
    <template #body>
      <!-- eslint-disable-next-line  vue/no-v-html -->
      <div v-if="isHtmlMessage" v-html="message" />
      <div v-else class="text-small-normal text-[--color-neutral-neutral]">
        <p>{{ message }}</p>
      </div>
    </template>
    <template #footer>
      <div v-if="!$slots.footer" :class="cx('flex w-full items-center gap-[16px]', footerClass)">
        <Button
          v-bind="{
            class: cx('w-full', rejectClass),
            outlined: true,
            severity: 'secondary',
            label: (rejectLabel)? rejectLabel: 'Cancel',
            ...rejectBtnProps,
          }"
          @click="emit('onReject')"
        />
        <Button
          v-bind="{
            class: cx('w-full', acceptClass),
            icon: hasAcceptIcon ? 'check' : '',
            label: (acceptLabel)? acceptLabel: 'Yes',
            iconClass: 'size-[14px]',
            ...acceptBtnProps,
          }"
          @click="emit('onAccept')"
        />
      </div>
      <slot v-if="$slots.footer" name="footer" />
    </template>
  </BaseDialogFrame>
</template>

<script lang="ts" setup>
import Button from '@/common/components/atoms/Button';
import BaseDialogFrame from '@/common/components/molecules/BaseDialogFrame';
import { cx } from '@/helpers/cva';

withDefaults(defineProps<{
  message: string | null,
  header: string,
  closeable?: boolean,
  footerClass?: string | object,
  acceptLabel?: string | undefined | null,
  acceptClass?: string | object,
  rejectLabel?: string | undefined | null,
  acceptBtnProps?: object,
  rejectBtnProps?: object,
  rejectClass?: string | object,
  isHtmlMessage?: boolean,
  hasAcceptIcon?: boolean,
  headerClass?: string | object,
}>(), {
  isHtmlMessage: true,
  closeable: false,
  footerClass: '',
  rejectLabel: undefined,
  acceptLabel: undefined,
  rejectClass: '',
  acceptClass: '',
  hasAcceptIcon: true,
  headerClass: '',
  acceptBtnProps: () => ({} as object),
  rejectBtnProps: () => ({} as object),
});

const emit = defineEmits<{
  'onAccept': [];
  'onReject': [];
}>();
</script>


